import {
  NetworkError,
  deepCamelCase,
  deepSnakeCase,
  Select,
  intoSnakeCase,
} from '../fetchers/_helpers';
import { GuestUserFields, GuestUser } from '../models/components/schemas/guest-user/GuestUser';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type PostGuestUsersFields = readonly GuestUserFields[];

/** Options for POST /guest_users */
export type PostGuestUsersOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  /** Available fields on the response type, application/vnd.vimeo.guestuser+json */
  select: Paths;

  /** Data serialized to body for POST /guest_users */
  variables: {
    /**
     * The email address of the guest user.
     * @example john@mail.com
     */

    email: string;

    /**
     * The name of the guest user.
     * @example Sam Doe
     */

    name: string;
  };
};

/** Result type for POST /guest_users */
export type PostGuestUsersResult<Paths extends readonly string[]> = Select<GuestUser, Paths>;

/**
 * Create a guest user
 * This method creates a guest user.
 */
export async function postGuestUsers<Paths extends PostGuestUsersFields>({
  baseUrl,
  select,
  variables,
  ...options
}: PostGuestUsersOptions<Paths>): Promise<PostGuestUsersResult<Paths>> {
  let res = await fetch(`${baseUrl}/guest_users?fields=${select.map(intoSnakeCase).join(',')}`, {
    ...options,
    method: 'POST',
    body: JSON.stringify(deepSnakeCase(variables)),
  });

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as PostGuestUsersResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}
